module.exports = __webpack_public_path__ + "static/media/celebrity.efb66529.jpg";